module.exports = __webpack_public_path__ + "static/media/tools-addnote2.b38b862b.svg";